import { render, staticRenderFns } from "./baseLevelModification.vue?vue&type=template&id=4ae74a82&scoped=true&"
import script from "./baseLevelModification.vue?vue&type=script&lang=js&"
export * from "./baseLevelModification.vue?vue&type=script&lang=js&"
import style0 from "./baseLevelModification.vue?vue&type=style&index=0&id=4ae74a82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae74a82",
  null
  
)

export default component.exports